export const pipeContainerStyle = (height, width, containerStyle) => {
    return {
        height: height,
        width: width,
        ...containerStyle
    };
};

export const verticalPipeStyle = (height, left, top = 0) => {
    return {
        position: 'absolute',
        backgroundColor: '#D7D7D7',
        height: height,
        width: 1,
        marginLeft: left,
        marginTop: top
    };
};

export const horizontalPipeStyle = (height, width, textWidth = 0, left) => {
    if (isNaN(left)) left = 0;

    return {
        position: 'absolute',
        backgroundColor: '#D7D7D7',
        height: 1,
        width: (width - textWidth - 10) / 2,
        marginLeft: left,
        marginTop: height
    };
};

export const completePipeStyle = (height, width, left) => {
    return {
        position: 'absolute',
        backgroundColor: '#D7D7D7',
        height: 1,
        width: width - 8,
        marginLeft: left,
        marginTop: height
    };
};

export const textStyle = (height, width, textWidth = 0) => {
    return {
        position: 'absolute',
        color: '#414141',
        fontFamily: 'Roboto',
        fontSize: 12,
        fontWeight: 500,
        marginLeft: (width - textWidth + 10) / 2,
        marginTop: height - 6
    };
};
